<template>
  <div class="bg-primary hover:bg-blue-700 rounded-lg p-2 cursor-pointer">
    <slot @click="$attrs.onClick" />
  </div>
</template>

<script setup>

</script>

<style scoped>

</style>